<script setup lang="ts">
import { toRef } from 'vue'
import type { PlayerTrack } from '~/stores/player'
import { useSongLike } from '../music/useSongLike'
import MmIcon from '../base/MmIcon.vue'
defineOptions({ inheritAttrs: false })
const props = withDefaults(defineProps<{ song: PlayerTrack; small?: boolean; iconSize?: number }>(), { small: false, iconSize: 24 })
const { t } = useI18n()
const { liked, busy, failed, toggle } = useSongLike(toRef(props, 'song'))
</script>
<template><button v-bind="$attrs" type="button" class="icon-btn like" :class="{ sm: small }" :aria-label="t('t24a.like')" :title="t(liked ? 'mm.song.unlikeTrack' : 'mm.song.likeTrack', { title: song.title, count: song.like_count || 0 })" :aria-pressed="liked" :aria-busy="busy" :disabled="busy" @click="toggle"><MmIcon name="heart" :size="iconSize" /></button><span v-if="failed" role="alert" class="mm-sr-only">{{ t('common.operation_failed') }}</span></template>
